import { Component, HostBinding } from '@angular/core';
import { AsyncPipe } from '@angular/common';

import { MinimalHeaderContainerComponent } from '../../shared/minimal-header';
import { MinimalStickyHeaderComponent } from '../minimal-sticky-header.component';

@Component({
  selector: 'wl-minimal-sticky-header-container',
  templateUrl: './minimal-sticky-header-container.component.html',
  styleUrls: [],
  standalone: true,
  imports: [MinimalStickyHeaderComponent, AsyncPipe],
})
export class MinimalStickyHeaderContainerComponent extends MinimalHeaderContainerComponent {
  @HostBinding('class')
  class = 'd-block sticky-top';

  constructor() {
    super();
  }
}
